/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Products } from '../models/products';
import { updateStocks } from '../fn/stock/update-stocks';
import { UpdateStocks$Params } from '../fn/stock/update-stocks';


/**
 * Product stock/availability synchronization. Accepts HardBit-compatible XML payloads and updates product availability in the marketplace.
 */
@Injectable({ providedIn: 'root' })
export class StockService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateStocks()` */
  static readonly UpdateStocksPath = '/stocks';

  /**
   * Synchronize product availability (HardBit / XML format).
   *
   * Accepts a bulk XML stock update payload and synchronizes product availability into the marketplace.
   *
   * **Authentication**
   *
   * Requires a Bearer JWT token in the `Authorization` header. 
   * The token identifies the merchant whose product availability is being updated.
   *
   * **Required authority (one of):**
   * - `EASYLOT_ADMIN`
   * - `STOCK_SYNC`
   * - `PRICE_SYNC_ADMIN`
   *
   * **Business preconditions**
   *
   * - A valid PRS configuration must exist for the merchant/site identified by the token.
   * - Each product SKU must have an existing product mapping (SKU → productId) in PRS.
   *   Missing mappings do not cause HTTP-level failure; they produce item-level errors in the response.
   *
   * **HTTP 200 does not mean full success**
   *
   * The HTTP status reflects request acceptance, not individual product processing outcome. 
   * Always check the `Status` field of each `Product` element in the response XML.
   *
   * **Request example:**
   * ```xml
   * <Products>
   *     <Product>
   *         <Sku>SKU-001</Sku>
   *         <Stocks>
   *             <Stock>
   *                 <Qty>42</Qty>
   *             </Stock>
   *         </Stocks>
   *     </Product>
   * </Products>
   * ```
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStocks()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  updateStocks$Response(params: UpdateStocks$Params, context?: HttpContext): Observable<StrictHttpResponse<Products>> {
    const obs = updateStocks(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Synchronize product availability (HardBit / XML format).
   *
   * Accepts a bulk XML stock update payload and synchronizes product availability into the marketplace.
   *
   * **Authentication**
   *
   * Requires a Bearer JWT token in the `Authorization` header. 
   * The token identifies the merchant whose product availability is being updated.
   *
   * **Required authority (one of):**
   * - `EASYLOT_ADMIN`
   * - `STOCK_SYNC`
   * - `PRICE_SYNC_ADMIN`
   *
   * **Business preconditions**
   *
   * - A valid PRS configuration must exist for the merchant/site identified by the token.
   * - Each product SKU must have an existing product mapping (SKU → productId) in PRS.
   *   Missing mappings do not cause HTTP-level failure; they produce item-level errors in the response.
   *
   * **HTTP 200 does not mean full success**
   *
   * The HTTP status reflects request acceptance, not individual product processing outcome. 
   * Always check the `Status` field of each `Product` element in the response XML.
   *
   * **Request example:**
   * ```xml
   * <Products>
   *     <Product>
   *         <Sku>SKU-001</Sku>
   *         <Stocks>
   *             <Stock>
   *                 <Qty>42</Qty>
   *             </Stock>
   *         </Stocks>
   *     </Product>
   * </Products>
   * ```
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStocks$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  updateStocks(params: UpdateStocks$Params, context?: HttpContext): Observable<Products> {
    const resp = this.updateStocks$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Products>): Products => r.body)
    );
  }

}
